import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const permissionAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<MasterDataType>>('/api/info/permissions', { params }).then(({ data }) => data),

  user_permission: (id: number | string) =>
    http.get<DataResponse<UserPermission>>(`/api/info/users/${id}/permissions`).then(({ data }) => data),
  update_user_permission: (id: number | string, data: UserPermissionPayload) =>
    http.patch(`/api/edit/users/${id}/permissions`, { data }),
};

export const permissionQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetPermissionList', params] as const,
      queryFn: () => permissionAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  user_permission: (id: number | string) =>
    ({
      queryKey: ['GetUserPermission', id] as const,
      queryFn: () => permissionAPI.user_permission(id),
    }) as const satisfies QueryOptions,
};
